import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import BeginnerUsed from './modules/beginnerUsed';
import ProductManager from './modules/productManage';
import QuestionManage from './modules/questionManage';
import User from './modules/user';
import UserFeedback from './modules/userFeedback';
import Other from './modules/other';

const store = new Vuex.Store({
  modules: {
    User,
    ProductManager,
    BeginnerUsed,
    QuestionManage,
    UserFeedback,
    Other
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js